import { initialState } from "./initialState"
import type { GraphActions, GraphStore } from "./types"

export const createGraphActions = (
  set: (partial: Partial<GraphStore>) => void,
  get: () => GraphStore
): GraphActions => ({
  setRootCustomerId: (rootCustomerId) => {
    set({ rootCustomerId })
  },

  setSelectedVertices: (vertices) => {
    set({ selectedVertices: vertices })
  },

  toggleVertexSelection: (vertexId) => {
    const { selectedVertices } = get()
    set({
      selectedVertices: selectedVertices.includes(vertexId)
        ? selectedVertices.filter((id) => id !== vertexId)
        : [...selectedVertices, vertexId]
    })
  },

  setHoveredNode: (node) => {
    set({ hoveredNode: node })
  },

  toggleSidebarLock: (node) => {
    const { sidebarLockedNode } = get()

    // If already locked to the same node, unlock and hide
    if (sidebarLockedNode?.id === node.id) {
      set({
        sidebarLockedNode: null,
        sidebarVisible: false
      })
    } else {
      // Lock to the new node and show sidebar
      set({
        sidebarLockedNode: node,
        sidebarVisible: true
      })
    }
  },

  closeSidebar: () => {
    set({
      sidebarLockedNode: null,
      sidebarVisible: false
    })
  },

  setDisableInteractions: (disable) => {
    set({ disableInteractions: disable })
  },

  setCanvasDimensions: (width, height) => {
    set({ canvasWidth: width, canvasHeight: height })
  },

  setPanPosition: (position) => {
    set({ panPosition: position })
  },

  setZoomLevel: (zoom) => {
    set({ zoomLevel: zoom })
  },

  resetPanAndZoom: () => {
    set({ panPosition: { x: 0, y: 0 }, zoomLevel: 1 })
  },

  resetStore: () => {
    const { rootCustomerId } = get()
    set({ ...initialState, rootCustomerId })
  }
})
